import React from 'react'
import { Container } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive';

const Visit = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
  return (
    <div className={`visit-section section-padding  `}>
        <div>
            <div className={`${isMobile ? 'text-start' : ''} ps-3`}>
            {isMobile ? 
            <><h1>Visit IRA Aspiration </h1>
            <h1>in Kollur</h1></> : 
            <h1>Visit IRA Aspiration in Kollur</h1>
            }
            {isMobile && 
            <>
            <span className='text-capitalize'>Ready to explore your new home?</span><br/>
            <span className='text-capitalize'>Contact us today to book a visit and <br/>see Kollur’s best ready-to-move in 2 & 3 <br/>BHK apartments.</span>
            <span className='text-capitalize'>book your personalized <br/>site visit.</span>
            </>
            }
            {(!isMobile) && 
                <>
                <span className='text-capitalize'>Ready to explore your new home?</span><br/>
                <span className='text-capitalize'>Contact us today to book a visit and see Kollur’s best ready-to-move in 2 & 3 BHK apartments.</span><br/>
                <span className='text-capitalize'>book your personalized site visit.</span>
                </>
            }
            </div>
        </div>
    </div>
  )
}

export default Visit
